export function getCategoryQuerySlug(slug: string | string[] | undefined): string | undefined {
  if (typeof slug === 'undefined') return undefined;
  if (Array.isArray(slug)) {
    const filteredArray: string[] = slug.filter((item) => item !== 'categories');
    return filteredArray.join('|');
  }
  const slugSplit = slug.split('/');
  const filteredArray: string[] = slugSplit.filter((item) => item !== 'categories');
  return filteredArray.join('|');
}
